const stripTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const defaultApiBase =
  typeof window !== "undefined" ? stripTrailingSlash(window.location.origin) : "";

export const API = stripTrailingSlash(
  process.env.REACT_APP_FASTAPI_URL || defaultApiBase
);

export const RULES_API = stripTrailingSlash(
  process.env.REACT_APP_RULES_URL || `${API}/api`
);

if (!API) {
  throw new Error("API base URL is not configured.");
}

const decodeB64Url = (s: string) => {
  s = s.replace(/-/g, "+").replace(/_/g, "/");
  const pad = s.length % 4;
  if (pad) s += "=".repeat(4 - pad);
  return atob(s);
};

export const decodePayload = (token: string) =>
  JSON.parse(decodeB64Url(token.split(".")[1] || ""));

export const clearSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expires_at");
};

export const getToken = () => localStorage.getItem("token") || "";
export const getExpiresAt = () => Number(localStorage.getItem("expires_at") || 0);

export const saveSession = (token: string) => {
  const payload = decodePayload(token);
  const exp = Number(payload.exp || 0);

  localStorage.setItem("token", token);
  if (exp > 0) {
    localStorage.setItem("expires_at", String(exp * 1000));
  } else {
    localStorage.removeItem("expires_at");
  }
};

export const tokenExpired = () => {
  const t = getToken();
  const exp = getExpiresAt();
  if (!t || !exp) return true;
  return Date.now() > exp;
};

export const logout = (silent = false) => {
  clearSession();
  if (!silent) window.location.href = "/login";
};

export const startExpiryTimer = () => {
  const exp = getExpiresAt();
  if (!exp) return;

  const ms = exp - Date.now();
  if (ms <= 0) return logout();

  const w = window as any;
  if (w.__expiryTimer) clearTimeout(w.__expiryTimer);
  w.__expiryTimer = setTimeout(() => {
    alert("Session has expired. Please log in again.");
    logout();
  }, ms);
};
